exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._10X3b{max-width:1080px;width:100%;display:block;margin:0 auto}._3q-_8{font-size:44px;font-weight:400}h1:first-child{margin-top:0}._2W39y,p{font-size:14px}._2W39y{color:#484848}._2D_aO,._3pRa2{font-size:16px}._2D_aO{border-radius:0;width:100%;display:block;color:#484848;padding-bottom:12px;border-bottom:1px solid #dce0e0}.NBhtQ{display:block;padding:14px 15px;position:relative;text-align:center;font-size:14px;color:#767676;cursor:pointer;border-bottom:5px solid transparent}._1c8m_ .NBhtQ,.NBhtQ:hover{text-decoration:none;color:#484848}._1c8m_ .NBhtQ{border-color:#aaa}._1T2Vf{margin:0}._1pOJ0{margin-top:100px;padding-bottom:50px;position:relative}._2rV3y{margin-left:0;margin-right:0}._35Uae{text-align:center;height:24px}._2e3sp{position:absolute;right:-30px;top:0}._28vnJ{background-color:#3fb34f}.tbCtF{background-color:#ffb400}._3GGTz{background-color:#ff5a5f}.qZIEP{position:relative;opacity:1;padding:6px 10px;left:-50%;top:-60px;background-color:#fff}._350Ua{height:12px;width:12px;border-radius:50%;position:absolute;top:6px;left:-6px;background:#fff}.IlBG2{position:relative;left:-50%;top:3px;text-align:center}._3IAJj{margin-top:30px}@media screen and (max-width:640px){._2qva2{display:none}}._1zbuI{margin-bottom:12px}", ""]);

// exports
exports.locals = {
	"landingContainer": "_10X3b",
	"landingTitle": "_3q-_8",
	"subText": "_2W39y",
	"textGray": "_3pRa2",
	"panelHeader": "_2D_aO",
	"tabItem": "NBhtQ",
	"active": "_1c8m_",
	"noMargin": "_1T2Vf",
	"lineGraph": "_1pOJ0",
	"graphContainer": "_2rV3y",
	"timeLine": "_35Uae",
	"timeLinePoint": "_2e3sp",
	"refund": "_28vnJ",
	"semiRefund": "tbCtF",
	"nonRefund": "_3GGTz",
	"toolTop": "qZIEP",
	"toolMarker": "_350Ua",
	"toolLable": "IlBG2",
	"toolText": "_3IAJj",
	"hidesm": "_2qva2",
	"space2": "_1zbuI"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/CancellationPolicies/CancellationPolicies.css
// module id = 2524
// module chunks = 15